import { Component } from '@angular/core';
import { AppUrls } from 'projects/bis-shared/src/lib/utility/appurls';
import { EnvironmentService } from '../../environment/environment.service';

@Component({
  selector: 'lib-unauthorized',
  templateUrl: './unauthorized.component.html',
  styleUrls: ['./unauthorized.component.scss'],
})
export class UnauthorizedComponent {
  homeUrl: string;
  appType: string;
  contactInfo = 'your supervisor';

  constructor(private environmentService: EnvironmentService) {
    this.homeUrl = AppUrls.home();

    if (this.environmentService.isExternalSite) {
      this.contactInfo = 'your organization’s online user administrator';
    } else {
      this.contactInfo = 'your supervisor';
    }
  }
}
